import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import AppInput from '../../common/AppInput';
import AppSelect from '../../common/AppSelect';
import Message from '../../common/Message';
import { callGetRegionService } from '../../../services/GeoService';
import {
  HELPER_COMPLETE,
  BETTER_ATTENTION,
  INVALID_NUMBER_REQUEST,
} from '../../../constants/texts';
import { useDebitStyles } from './styles';
import { optionMapper } from '../../../helpers/tickets/PaymentTypeHelper';

const Form = ({ ...props }) => {
  const { state, onData, fields } = props;
  const classes = useDebitStyles();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await callGetRegionService();
        const data = response.data.data;
        if (data?.length > 0) {
          const formattedRegions = data.map((region) => {
            return {
              id: region.id,
              name: region.name,
              children: region.children || [], // Include children for city options
            };
          });
          setStates(formattedRegions);
          // Initialize with the first region and its first city
          const firstRegion = formattedRegions[0];
          if (firstRegion) {
            onData({ name: 'state', value: firstRegion.name });
            setCities(
              firstRegion.children.map((city) => ({
                id: city,
                name: city.name,
              })),
            );
            if (firstRegion.children?.length > 0) {
              onData({ name: 'city', value: firstRegion.children[0]?.name });
            }
          }
          setCities([]);
          onData({ name: 'state', value: '' });
          onData({ name: 'city', value: '' });
        }
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };
    fetchRegions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onData({ name, value });
  };

  const handleCityChange = (e) => {
    const { value } = e.target;
    onData({ name: 'city', value });
  };

  const handleStateChange = (e) => {
    const { value } = e.target;
    const selectedState = states.find((state) => state.id === value.id);
    const stateName = selectedState?.name || '';
    onData({ name: 'state', value: stateName });

    console.log(selectedState);

    if (selectedState) {
      const cityOptions = selectedState.children.map((city) => ({
        id: city.name,
        name: city.name,
      }));
      setCities(cityOptions);
    } else {
      setCities([]);
    }
  };

  return (
    <React.Fragment>
      <Typography className={classes.title}> {HELPER_COMPLETE} </Typography>

      <Box className={classes.info}>
        <Message fullRounded severity="info" message={BETTER_ATTENTION} />
      </Box>

      {state['aurisTicketId']?.value === '' && (
        <Box className={classes.info}>
          <Message
            fullRounded
            severity="alert"
            message={INVALID_NUMBER_REQUEST}
          />
        </Box>
      )}

      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {field.inputType !== 'select' && !field.hidden && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}

          {field.inputType === 'select' && (
            <AppSelect
              label={state[field.name]?.label || ''}
              name={field.name}
              options={
                field.name === 'state'
                  ? states.map((region) => ({
                      id: region,
                      name: region.name,
                    }))
                  : field.name === 'city'
                  ? cities
                  : optionMapper.get(field.name)
              }
              onChange={
                field.name === 'state'
                  ? handleStateChange
                  : field.name === 'city'
                  ? handleCityChange
                  : handleChange
              }
              required={state[field.name]?.required || false}
              onClick={() => {}}
              onBlur={() => {}}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
};

export default Form;
